import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { memo, useEffect, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import windowWidth from '@outdoor-voices/ui/dist/utils/dom/windowWidth';
import { Social, GroupColumns } from './Links';
import css from './WithEmail.module.scss';
import EmailCaptureLite from '../EmailCaptureLite';
import EmailCaptureName from '../EmailCaptureName';
import outerHeight from '../../utils/dom/outerHeight';
import useEventListener from '../../utils/hooks/useEventListener';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var EFFECT_WIDTH_MINIMUM = 960;
var EFFECT_HEIGHT_MAXIMUM = 683;
var MAIN_CONTENT_SELECTOR = '#main-content';
var MAIN_Z_INDEX = 2;

var currentRootHeight = function currentRootHeight() {
  var root = document.querySelector(".".concat(css.root));
  return outerHeight(root);
};

var FooterWithEmail = function FooterWithEmail(_ref) {
  var fixBehind = _ref.fixBehind,
      hasBackgroundColor = _ref.hasBackgroundColor,
      links = _ref.links,
      listId = _ref.listId,
      nameOnly = _ref.nameOnly,
      source = _ref.source;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      screenWidth = _useState4[0],
      setScreenWidth = _useState4[1];

  var validEffectHeight = height <= EFFECT_HEIGHT_MAXIMUM;
  var validEffectWidth = screenWidth >= EFFECT_WIDTH_MINIMUM;
  var canUseEffect = validEffectWidth && fixBehind;
  useEffect(function () {
    var content = document.querySelector(MAIN_CONTENT_SELECTOR);

    if (content && content.style) {
      content.style.marginBottom = canUseEffect ? "".concat(height, "px") : '';
      content.style.zIndex = canUseEffect ? MAIN_Z_INDEX : '';
      content.style.backgroundColor = canUseEffect ? 'white' : '';
    }
  }, [height, canUseEffect]);
  useEventListener('resize', function () {
    setHeight(currentRootHeight());
    setScreenWidth(windowWidth());
  });
  useEffect(function () {
    var rootHeight = currentRootHeight();
    setHeight(!validEffectHeight ? rootHeight : EFFECT_HEIGHT_MAXIMUM);
    setScreenWidth(windowWidth());
  }, [validEffectHeight]);
  var light = !!hasBackgroundColor;
  var EmailCapture = nameOnly ? EmailCaptureName : EmailCaptureLite;
  return /*#__PURE__*/_jsx("footer", {
    className: cc([css.root, css[hasBackgroundColor], _defineProperty({}, css.light, light), _defineProperty({}, css.fixBehind, fixBehind && canUseEffect)]),
    children: /*#__PURE__*/_jsxs("div", {
      className: css.contentWrap,
      children: [/*#__PURE__*/_jsx("section", {
        className: css.side,
        children: /*#__PURE__*/_jsx(EmailCapture, {
          light: light,
          listId: listId,
          source: source
        })
      }), /*#__PURE__*/_jsxs("section", {
        className: cc([css.side, css.links]),
        children: [/*#__PURE__*/_jsx("div", {
          className: css.columns,
          children: /*#__PURE__*/_jsx(GroupColumns, {
            light: light,
            links: links,
            rootClass: css.column,
            linkClass: css.link
          })
        }), /*#__PURE__*/_jsx(Social, {
          light: light
        })]
      })]
    })
  });
};

FooterWithEmail.propTypes = {
  fixBehind: PropTypes.bool.isRequired,
  hasBackgroundColor: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  links: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  listId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  nameOnly: PropTypes.bool,
  source: PropTypes.string
};
FooterWithEmail.defaultProps = {
  hasBackgroundColor: false,
  listId: false,
  nameOnly: false,
  source: ''
};
export default /*#__PURE__*/memo(FooterWithEmail);